export const ColorsStyles = {
    colorButton: "#7092be",
    colorTextError: "#fcb900",
    backgroundFooter: "#021f2d",
    colorHr: "#b3b3b3",

    colorInput: "#7092be",
    background: "#fff",
    backgroundTwo: "rgba(112, 146, 190, 0.6)",
    backgroundTwoHover: "rgba(112, 146, 190, 0.45)",
    backgroundInput: "#e0e6f1",
    borderInput: {
        width: 0,
        color: "#fff",
    },
    colorTextInput: "#212529",
    colorTextFilter: "#7e7e7e",
};
